import React from "react";
import { Box, MenuItem } from "@mui/material";

/** @param {Array<{ id: string, name: string, rate: number, unit?: string }>} resources */
export const formatResourceLabel = (resource) => {
  if (!resource) return "—";
  const rate = Number(resource.rate);
  const rateStr = Number.isFinite(rate) ? rate.toFixed(2) : "0.00";
  const unit = resource.unit === "$" ? "$" : "hr";
  if (unit === "$") {
    return `${resource.name} ($${rateStr})`;
  }
  return `${resource.name} (${rateStr}/${unit})`;
};

/** @param {Array<{ id: string, name: string, rate: number }>} resources */
export const buildResourceColumn = (resources = []) => ({
  accessorKey: "resourceId",
  header: "Resource",
  size: 140,
  enableSorting: false,
  enableEditing: true,
  Cell: ({ row }) => {
    const id = row.original.resourceId;
    const resource =
      row.original.resource ||
      resources.find((r) => r.id === id);
    return (
      <Box component="span" sx={{ fontSize: "0.85rem" }}>
        {formatResourceLabel(resource)}
      </Box>
    );
  },
  muiEditTextFieldProps: {
    select: true,
    children: [
      <MenuItem key="__none__" value="">
        None
      </MenuItem>,
      ...resources.map((r) => (
        <MenuItem key={r.id} value={r.id}>
          {formatResourceLabel(r)}
        </MenuItem>
      )),
    ],
  },
});

/** Normalize resourceId for PATCH payloads (empty string → null). */
export const normalizeResourceIdForSave = (value) => {
  if (value === "" || value === undefined) return null;
  return value;
};
